import React from "react";

const AsSeenOn = () => {
  const trustedLogos = [
    "./../assets/images/as_seen_on/kayafm.svg",
    "./../assets/images/as_seen_on/capetalk.svg",
    "./../assets/images/as_seen_on/metro fm.svg",
    "./../assets/images/as_seen_on/radio2000.svg",
    "./../assets/images/as_seen_on/702fm.svg",
    "./../assets/images/as_seen_on/touchhd.svg",
  ];

  return (
    <div className=" d-flex flex-wrap company-logo-main mt-5 justify-content-center">
      {trustedLogos.map((src, index) => (
        <span key={index} className="pt--5 pb--5 ">
          <img
            src={src}
            className="h--110 w--200 object-fit--contain h--sm-130"
            alt={`As Seen On-${index}`}
          />
        </span>
      ))}
    </div>
  );
};

export default AsSeenOn;
